/**
 * Franja de ambiente + marca de agua de impresión — estándar `config-y-ambientes` de Bedekken.
 *
 * - La franja no se puede cerrar y va arriba de todo, también en el login.
 * - En producción no se renderiza nada.
 * - La marca de agua existe solo en @media print (cubre el "Imprimir / PDF" del navegador).
 */
import React from "react";
import { ENTORNO, colorDeEntorno } from "./entorno";

const PALABRA = "PRUEBA";
const SUBTITULO = `Ambiente ${ENTORNO.sigla} · no es una solicitud real`;

// fija: la franja queda pegada arriba del viewport (para layouts con header fijo, como Metronic).
export function FranjaDeAmbiente({ fija = false }) {
  if (ENTORNO.esProd) return null;
  const estilo = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    height: 24,
    padding: "0 16px",
    fontSize: 12,
    fontWeight: 500,
    lineHeight: "24px",
    textAlign: "center",
    color: "#ffffff",
    background: colorDeEntorno(),
    ...(fija ? { position: "fixed", top: 0, left: 0, right: 0, zIndex: 1100 } : {}),
  };
  return (
    <div role="status" style={estilo} className="franja-ambiente">
      <style>{"@media print { .franja-ambiente { display: none !important; } }"}</style>
      <span style={{ borderRadius: 4, background: "rgba(0,0,0,0.25)", padding: "1px 6px", fontSize: 10, fontWeight: 700, letterSpacing: "0.08em", lineHeight: "16px" }}>
        {ENTORNO.sigla}
      </span>
      <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{ENTORNO.leyenda}</span>
    </div>
  );
}

export function MarcaDeAguaDeImpresion() {
  if (ENTORNO.esProd) return null;
  return (
    <div aria-hidden="true" className="marca-agua-ambiente">
      <style>
        {".marca-agua-ambiente { display: none; }" +
          "@media print { .marca-agua-ambiente { display: grid; position: fixed; top: 0; right: 0; bottom: 0; left: 0; z-index: 50;" +
          " place-items: center; pointer-events: none; } }"}
      </style>
      <div style={{ transform: "rotate(-35deg)", textAlign: "center", color: colorDeEntorno(), opacity: 0.15 }}>
        <p style={{ fontSize: 110, fontWeight: 700, lineHeight: 1, margin: 0 }}>{PALABRA}</p>
        <p style={{ fontSize: 18, fontWeight: 600, marginTop: 8 }}>{SUBTITULO}</p>
      </div>
    </div>
  );
}
